module.exports = __webpack_public_path__ + "img/MP-Habitat-Logo-Dark.f16404dc.svg";